import toast from 'react-hot-toast';
import { ADD_NEW_HOMESLIDE } from './HomeSlideRedux';

export const FETCH_ALL_NEWSEVENTS = 'FETCH_ALL_NEWSEVENTS';
// export const GET_PRODUCTS_DETAIL = 'GET_PRODUCTS_DETAIL';
export const ADD_NEW_NEWSEVENTS = 'ADD_NEW_NEWSEVENTS';
export const SET_SELECTED_NEWSEVENTS_ROW = 'SET_SELECTED_NEWSEVENTS_ROW';
export const CLEAR_DATA = 'CLEAR_DATA';

const initialState = {
  allNewsEvents: [],
  //   getProductDetails: [],
  addNewsEvents: [],
  selectedNewsEventsRow: {},
};

const NewsEventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_NEWSEVENTS:
      return {
        ...state,
        allNewsEvents: action.payload,
      };
    // case GET_PRODUCTS_DETAIL:
    //   return {
    //     ...state,
    //     getProductDetails: action.payload,
    //   };
    case ADD_NEW_HOMESLIDE:
      return {
        ...state,
        addNewsEvents: action.payload,
      };
    case SET_SELECTED_NEWSEVENTS_ROW:
      return {
        ...state,
        selectedNewsEventsRow: action.payload,
      };
    case CLEAR_DATA:
      return {
        ...state,
        selectedNewsEventsRow: {},
        error: null,
      };
    default:
      return state;
  }
};

export default NewsEventsReducer;

export const fetchAllNewsEvents = (data) => ({
  type: FETCH_ALL_NEWSEVENTS,
  payload: data,
});
// export const productDetails = (data) => ({
//   type: GET_PRODUCTS_DETAIL,
//   payload: data,
// });
export const addNewNewsEvents = (data) => ({
  type: ADD_NEW_NEWSEVENTS,
  payload: data,
});
export const clearData = () => ({
  type: CLEAR_DATA,
});
export const setSelectedNewsEventsRow = (data) => ({
  type: SET_SELECTED_NEWSEVENTS_ROW,
  payload: data,
});

export const getAllNewsEvents = () => {
  return async (dispatch) => {
    const promise = (async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/nrcb/ecom/get/news-events`,
          { method: 'GET' }
        );

        if (!response.ok) {
          if (response.status === 404) {
            dispatch(clearData());
          } else {
            throw new Error('Failed to get News & Events');
          }
        }

        const val = await response.json();
        dispatch(fetchAllNewsEvents(val));
        return val;
      } catch (error) {
        console.error('Failed to fetch News & Events:', error);
        throw new Error(error.message || 'Failed to fetch News & Events');
      }
    })();
    return promise;
  };
};


export const addNewsEvents = (sellerId, newProduct) => {
  return async (dispatch) => {
    const promise = (async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/nrcb/ecom/add/news-event/${sellerId}`,
          {
            method: 'POST',
            body: JSON.stringify(newProduct),
            headers: { 'Content-Type': 'application/json' },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          console.error('Server error:', errorData);
          const errorMessage = errorData.message || 'Failed to add News and Events';
          throw new Error(errorMessage);
        }

        const val = await response.json();
        dispatch(addNewNewsEvents(val));
        return val;
      } catch (error) {
        console.error('Error in adding new News and Events:', error);
        throw error;
      }
    })();

    toast.promise(promise, {
      loading: 'Adding New News and Events...',
      success: 'New News and Events Added',
      error: (error) => {
        return error.message || 'Failed to add News and Events';
      },
    });

    return promise;
  };
};
